// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#giveaway-excel-table[data-v-64ff26c0] {\n  border: 1px solid black;\n  border-collapse: collapse;\n}\n#giveaway-excel-table th[data-v-64ff26c0],\n  #giveaway-excel-table td[data-v-64ff26c0] {\n    border: 1px solid black;\n    border-collapse: collapse;\n}\n", ""]);
// Exports
module.exports = exports;
